module.exports = __webpack_public_path__ + "img/details.edd75a57.webp";